export default __webpack_public_path__ + "static/media/bumper-horizontal-pixel-logo.023bf243.svg";